// extracted by mini-css-extract-plugin
export default {"animation-fast-ms":"300","animation-slow-ms":"800","container":"index_container__34dj1","background":"index_background__1B2Uy","navigationGroups":"index_navigationGroups__1wbEk"};